import { Button, Card, Checkbox, Empty, Input, Select, Tabs } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { sortBy, uniqBy } from 'lodash';
import cmsFactory from '../../components/cmsFactory';
import ContentLibraryHeader from '../../components/navigation/ContentLibraryHeader';
import LabeledInput from '../../components/ui/LabeledInput';
import Search, { languageOptions, sortByOptions } from '../../components/contentDisplay/Search';
import { useHistoryState, useQueryStringArgs } from '../../lib/hooks';
import { useAnalytics } from '../../lib/analytics';
const SearchPage = ({
  data: {
    content
  }
}) => {
  const analytics = useAnalytics();
  const gradeOptions = useMemo(() => sortBy(uniqBy(content.flatMap(d => d.grades).filter(Boolean), 'id'), e => Number(e.id)).map(g => ({
    label: g.name,
    value: g.id
  })), [content]);
  const [queryStringArgs, setQueryStringArgs] = useQueryStringArgs();
  const searchQuery = queryStringArgs.kw || '';
  const setSearchQuery = kw => setQueryStringArgs({
    ...queryStringArgs,
    kw
  });
  const [languageFilter, setLanguageFilter] = useHistoryState('searchpage-language-filter', languageOptions.map(t => t.value));
  const [gradeFilter, setGradeFilter] = useHistoryState('searchpage-grade-filter', []);
  const [sort, setSort] = useHistoryState('searchpage-sort', sortByOptions[0]);
  const clearFilters = () => {
    setLanguageFilter(languageOptions.map(t => t.value));
    setGradeFilter([]);
    setSort(sortByOptions[0]);
  };

  // Log search event
  useEffect(() => {
    searchQuery && analytics?.track('Search', {
      query: searchQuery
    });
  }, [analytics, searchQuery]);
  const [searchInputVal, setSearchInputVal] = useState(searchQuery);
  useEffect(() => setSearchInputVal(searchQuery), [searchQuery]);
  return <div className="preview-module-container" data-sentry-component="SearchPage" data-sentry-source-file="search.jsx">
      <ContentLibraryHeader title="Search" data-sentry-element="ContentLibraryHeader" data-sentry-source-file="search.jsx" />
      <Card data-sentry-element="Card" data-sentry-source-file="search.jsx">
        <div style={{
        display: 'flex',
        marginBottom: 16
      }}>
          <Input.Search placeholder="Search from thousands of books and games." enterButton="Search" value={searchInputVal} onChange={e => setSearchInputVal(e.target.value)} onSearch={v => setSearchQuery(v)} size="large" style={{
          maxWidth: 500
        }} data-sentry-element="unknown" data-sentry-source-file="search.jsx" />
        </div>
        <div className="search-results-container">
          <div className="filter-container search-filter-aside">
            <LabeledInput label="Sort By" data-sentry-element="LabeledInput" data-sentry-source-file="search.jsx">
              <Select options={sortByOptions.map(k => ({
              label: k,
              value: k
            }))} value={sort} onChange={v => setSort(v)} data-sentry-element="Select" data-sentry-source-file="search.jsx" />
            </LabeledInput>
            <LabeledInput label="Grade" data-sentry-element="LabeledInput" data-sentry-source-file="search.jsx">
              <Checkbox.Group options={gradeOptions} value={gradeFilter} onChange={v => setGradeFilter(v)} data-sentry-element="unknown" data-sentry-source-file="search.jsx" />
            </LabeledInput>
            <LabeledInput label="Language" data-sentry-element="LabeledInput" data-sentry-source-file="search.jsx">
              <Checkbox.Group options={languageOptions} value={languageFilter} onChange={v => setLanguageFilter(v)} data-sentry-element="unknown" data-sentry-source-file="search.jsx" />
            </LabeledInput>
            <Button onClick={clearFilters} data-sentry-element="Button" data-sentry-source-file="search.jsx">
              Clear Filters
            </Button>
          </div>
          <div className="search-results">
          {searchQuery ? <Search query={searchQuery} grades={gradeFilter} languages={languageFilter} sortBy={sort} /> : <Empty description={'Search for something'} />}
          </div>
        </div>
      </Card>
    </div>;
};
export const getStaticProps = context => ({
  props: {
    dataURL: '/content/content-search-index.json'
  }
});
export default cmsFactory(SearchPage);